import { requestAuth, request } from 'services/http/instance'

const controllername = 'auth'

export const login = (data: any) =>
  requestAuth<any>({
    method: 'post',
    url: controllername + '/sign-in',
    data,
  })

export const sendVerificationCode = (data: any) =>
  requestAuth<any>({
    method: 'post',
    url: controllername + '/send-verification-code',
    data,
  })
export const refreshToken = () =>
  requestAuth<any>({
    method: 'post',
    url: controllername + '/refresh-token',
  })
export const userInfo = () =>
  request<any>({
    method: 'get',
    url: controllername + '/user-info',
  })
export const checkMaintenance = () =>
  request<any>({
    method: 'get',
    url: 'health-check/service-status',
  })

export const changeUser = (data: { userId: number; hotelId?: number }) =>
  request<any>({
    method: 'post',
    url: controllername + '/change-user',
    data,
  })
